module.exports = __webpack_public_path__ + "img/Noctiluca-Process-4-mobile.b8427d6d.png";